(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["soma-book-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('soma-book-menu')) {
    const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const MONTHS = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const MAX_GUESTS = 4;
    const TRIGGERS = { '#header-book': 'menu', '#header-book-bathhouse': 'bathhouse' };
    const pad = (n) => String(n).padStart(2, '0');
    const toIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const fromIso = (s) => {
      const [y, m, d] = s.split('-').map(Number);
      return new Date(y, m - 1, d);
    };
    const monthIndex = (d) => d.getFullYear() * 12 + d.getMonth();
    const addMonths = (d, n) => {
      const out = new Date(d.getFullYear(), d.getMonth() + n, 1);
      const last = new Date(out.getFullYear(), out.getMonth() + 1, 0).getDate();
      out.setDate(Math.min(d.getDate(), last));
      return out;
    };

    class SomaBookMenu extends HTMLElement {
      constructor() {
        super();
        this.isOpen = false;
        this.pinned = false;
        this.guests = 1;
        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onPointerEnter = this.onPointerEnter.bind(this);
        this.onPointerLeave = this.onPointerLeave.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onHashChange = this.onHashChange.bind(this);
        this.onDayClick = this.onDayClick.bind(this);
        this.onDayKeydown = this.onDayKeydown.bind(this);
        this.position = this.position.bind(this);
      }

      connectedCallback() {
        this.trigger = this.querySelector(':scope > .soma-btn');
        this.panel = this.querySelector('.sbm__panel');
        if (!this.trigger || !this.panel) return;

        this.menuView = this.panel.querySelector('.sbm__view--menu');
        this.calendarView = this.panel.querySelector('.sbm__view--calendar');
        this.bathhouseUrl = this.dataset.bathhouseUrl || '';
        this.productId = this.dataset.productId || '';
        this.available = null;
        this.loading = false;
        this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.setAttribute('aria-controls', this.panel.id);
        this.trigger.addEventListener('click', this.onTriggerClick);
        this.addEventListener('pointerenter', this.onPointerEnter);
        this.addEventListener('pointerleave', this.onPointerLeave);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('focusout', this.onFocusOut);

        if (this.calendarView) {
          this.monthTitle = this.calendarView.querySelector('.sbm__month-title');
          this.daysBody = this.calendarView.querySelector('.sbm__days');
          this.prev = this.calendarView.querySelector('.sbm__arrow--prev');
          this.next = this.calendarView.querySelector('.sbm__arrow--next');
          this.dateLine = this.calendarView.querySelector('.sbm__date');
          this.continueLink = this.calendarView.querySelector('.sbm__continue');
          this.guestsCount = this.calendarView.querySelector('.sbm__guests-count');
          this.minus = this.calendarView.querySelector('.sbm__step--minus');
          this.plus = this.calendarView.querySelector('.sbm__step--plus');
          this.minus.addEventListener('click', () => this.setGuests(this.guests - 1));
          this.plus.addEventListener('click', () => this.setGuests(this.guests + 1));

          this.panel.querySelector('.sbm__option--bathhouse')?.addEventListener('click', () => this.showCalendar());
          this.calendarView.querySelector('.sbm__back').addEventListener('click', () => this.showMenu(true));
          this.prev.addEventListener('click', () => this.changeMonth(-1));
          this.next.addEventListener('click', () => this.changeMonth(1));
          this.daysBody.addEventListener('click', this.onDayClick);
          this.daysBody.addEventListener('keydown', this.onDayKeydown);
        }

        document.addEventListener('click', this.onDocumentClick);
        window.addEventListener('hashchange', this.onHashChange);
        this.onHashChange();
      }

      disconnectedCallback() {
        this.close();
        document.removeEventListener('click', this.onDocumentClick);
        window.removeEventListener('hashchange', this.onHashChange);
        this.trigger?.removeEventListener('click', this.onTriggerClick);
        this.removeEventListener('pointerenter', this.onPointerEnter);
        this.removeEventListener('pointerleave', this.onPointerLeave);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('focusout', this.onFocusOut);
      }

      open() {
        clearTimeout(this.closeTimer);
        if (this.isOpen) return;
        this.isOpen = true;
        this.loadAvailability();
        this.panel.showPopover();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.position();
        document.addEventListener('pointerdown', this.onDocumentPointerDown);
        window.addEventListener('resize', this.position);
        window.addEventListener('scroll', this.position, { passive: true });
      }

      close(focusTrigger = false) {
        clearTimeout(this.closeTimer);
        if (!this.isOpen) return;
        this.isOpen = false;
        this.pinned = false;
        if (this.panel.matches(':popover-open')) this.panel.hidePopover();
        this.trigger.setAttribute('aria-expanded', 'false');
        this.showMenu(false);
        document.removeEventListener('pointerdown', this.onDocumentPointerDown);
        window.removeEventListener('resize', this.position);
        window.removeEventListener('scroll', this.position);
        if (focusTrigger) (this.opener?.isConnected ? this.opener : this.trigger).focus();
        this.opener = null;
      }

      openFrom(view, opener = null) {
        this.open();
        this.pinned = true;
        this.opener = opener;
        if (view === 'bathhouse' && this.calendarView) {
          this.showCalendar();
        } else {
          this.showMenu(false);
          this.panel.querySelector('.sbm__option')?.focus();
        }
      }

      onDocumentClick(event) {
        const link = event.target.closest?.('a[href*="#header-book"]');
        const view = link && TRIGGERS[link.hash];
        if (!view || link.origin !== location.origin || link.pathname !== location.pathname) return;
        event.preventDefault();
        this.openFrom(view, link);
      }

      onHashChange() {
        const view = TRIGGERS[location.hash];
        if (!view) return;
        history.replaceState(history.state, '', location.pathname + location.search);
        this.openFrom(view);
      }

      position() {
        const rect = this.trigger.getBoundingClientRect();
        if (rect.bottom < 0) {
          this.close();
          return;
        }
        const right = document.documentElement.clientWidth - rect.right;
        this.panel.style.setProperty('--sbm-top', `${Math.round(rect.bottom + 8)}px`);
        this.panel.style.setProperty('--sbm-right', `${Math.max(16, Math.round(right))}px`);
      }

      onTriggerClick() {
        if (!this.isOpen) {
          this.open();
          this.pinned = true;
        } else if (!this.pinned) {
          this.pinned = true;
        } else {
          this.close();
        }
      }

      onPointerEnter(event) {
        if (event.pointerType !== 'mouse' || !this.hoverQuery.matches) return;
        this.open();
      }

      onPointerLeave(event) {
        if (event.pointerType !== 'mouse' || !this.hoverQuery.matches) return;
        if (this.pinned || (this.calendarView && !this.calendarView.hidden)) return;
        this.closeTimer = setTimeout(() => this.close(), 200);
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !this.isOpen) return;
        event.preventDefault();
        this.close(true);
      }

      onFocusOut(event) {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      }

      onDocumentPointerDown(event) {
        if (!this.contains(event.target)) this.close();
      }

      showMenu(focus) {
        if (!this.calendarView || this.calendarView.hidden) return;
        this.calendarView.hidden = true;
        this.menuView.hidden = false;
        if (focus) this.panel.querySelector('.sbm__option--bathhouse')?.focus();
      }

      showCalendar() {
        this.pinned = true;
        this.setRange();
        if (!this.month) this.month = new Date(this.min.getFullYear(), this.min.getMonth(), 1);
        this.menuView.hidden = true;
        this.calendarView.hidden = false;
        this.render();
        this.daysBody.querySelector('.sbm__day[tabindex="0"]')?.focus();
      }

      loadAvailability() {
        if (!this.productId || !this.calendarView || this.availabilityRequested) return;
        this.availabilityRequested = true;
        this.loading = true;
        this.setRange();

        const booking = new URL(this.bathhouseUrl, window.location.origin);
        const api = new URL(
          `https://api.bookinglayer.io/public/products/${encodeURIComponent(this.productId)}/availabilities`
        );
        api.search = new URLSearchParams({
          format: 'choosable',
          show_available_only: '1',
          mode: 'checkin',
          start: toIso(this.min),
          end: toIso(this.max),
          genderless: '1',
          business_domain: booking.host,
        }).toString();

        fetch(api)
          .then((response) => {
            if (!response.ok) throw new Error(`Availability request failed: ${response.status}`);
            return response.json();
          })
          .then((json) => {
            const dates = json?.data?.dates || {};
            this.available = new Set(Object.keys(dates).filter((iso) => dates[iso]?.choosable !== false));
          })
          .catch((error) => {
            console.warn(error);
            this.available = null;
          })
          .finally(() => {
            this.loading = false;
            if (this.selected && !this.isAvailable(toIso(this.selected))) this.select(null);
            if (!this.calendarView.hidden) this.refresh();
          });
      }

      isAvailable(iso) {
        if (this.loading) return false;
        return !this.available || this.available.has(iso);
      }

      refresh() {
        const focused = this.daysBody.contains(document.activeElement) ? document.activeElement.dataset.date : '';
        this.render(focused ? fromIso(focused) : undefined);
        if (focused) this.focusDay(fromIso(focused));
      }

      setRange() {
        const today = new Date();
        this.min = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        this.max = addMonths(this.min, 6);
        if (this.selected && (this.selected < this.min || this.selected > this.max)) this.select(null);
        if (this.month && (monthIndex(this.month) < monthIndex(this.min) || monthIndex(this.month) > monthIndex(this.max))) {
          this.month = null;
        }
      }

      changeMonth(step) {
        const target = new Date(this.month.getFullYear(), this.month.getMonth() + step, 1);
        if (monthIndex(target) < monthIndex(this.min) || monthIndex(target) > monthIndex(this.max)) return;
        this.month = target;
        this.render();
      }

      render(focusDate) {
        const year = this.month.getFullYear();
        const month = this.month.getMonth();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const offset = (new Date(year, month, 1).getDay() + 6) % 7;
        const todayIso = toIso(this.min);
        const selectedIso = this.selected ? toIso(this.selected) : '';

        this.monthTitle.textContent = `${MONTHS[month]} ${year}`;
        this.prev.disabled = monthIndex(this.month) <= monthIndex(this.min);
        this.next.disabled = monthIndex(this.month) >= monthIndex(this.max);

        this.daysBody.closest('table').setAttribute('aria-busy', this.loading ? 'true' : 'false');

        let tabTarget = focusDate && focusDate.getMonth() === month ? toIso(focusDate) : '';
        let firstInRange = '';
        if (!tabTarget && this.selected && this.selected.getMonth() === month && this.selected.getFullYear() === year) {
          tabTarget = selectedIso;
        }

        const rows = [];
        let cells = [];
        for (let i = 0; i < offset; i++) cells.push(document.createElement('td'));

        for (let day = 1; day <= daysInMonth; day++) {
          const date = new Date(year, month, day);
          const iso = toIso(date);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'sbm__day';
          button.dataset.date = iso;
          button.textContent = day;
          button.tabIndex = -1;
          button.setAttribute('aria-label', `${DAYS[date.getDay()]} ${day} ${MONTHS[month]} ${year}`);
          button.setAttribute('aria-pressed', iso === selectedIso ? 'true' : 'false');
          if (iso === todayIso) button.setAttribute('aria-current', 'date');
          if (date < this.min || date > this.max) {
            button.disabled = true;
          } else {
            firstInRange = firstInRange || iso;
            if (!this.isAvailable(iso)) {
              button.setAttribute('aria-disabled', 'true');
              if (!this.loading) {
                button.classList.add('sbm__day--unavailable');
                button.setAttribute('aria-label', `${button.getAttribute('aria-label')}, unavailable`);
              }
            } else if (!tabTarget) {
              tabTarget = iso;
            }
          }

          const cell = document.createElement('td');
          cell.append(button);
          cells.push(cell);

          if (cells.length === 7) {
            rows.push(cells);
            cells = [];
          }
        }

        if (cells.length) {
          while (cells.length < 7) cells.push(document.createElement('td'));
          rows.push(cells);
        }

        this.daysBody.replaceChildren(
          ...rows.map((rowCells) => {
            const row = document.createElement('tr');
            row.append(...rowCells);
            return row;
          })
        );

        const tabbable = this.daysBody.querySelector(`[data-date="${tabTarget || firstInRange}"]`);
        if (tabbable) tabbable.tabIndex = 0;
      }

      focusDay(date) {
        const iso = toIso(date);
        const button = this.daysBody.querySelector(`[data-date="${iso}"]`);
        if (!button) return;
        this.daysBody.querySelectorAll('.sbm__day').forEach((day) => (day.tabIndex = -1));
        button.tabIndex = 0;
        button.focus();
      }

      onDayClick(event) {
        const button = event.target.closest('.sbm__day');
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        this.select(fromIso(button.dataset.date));
        this.focusDay(this.selected);
      }

      onDayKeydown(event) {
        const button = event.target.closest('.sbm__day');
        if (!button) return;

        const current = fromIso(button.dataset.date);
        const weekday = (current.getDay() + 6) % 7;
        let target;

        switch (event.key) {
          case 'ArrowLeft':
            target = new Date(current.getFullYear(), current.getMonth(), current.getDate() - 1);
            break;
          case 'ArrowRight':
            target = new Date(current.getFullYear(), current.getMonth(), current.getDate() + 1);
            break;
          case 'ArrowUp':
            target = new Date(current.getFullYear(), current.getMonth(), current.getDate() - 7);
            break;
          case 'ArrowDown':
            target = new Date(current.getFullYear(), current.getMonth(), current.getDate() + 7);
            break;
          case 'Home':
            target = new Date(current.getFullYear(), current.getMonth(), current.getDate() - weekday);
            break;
          case 'End':
            target = new Date(current.getFullYear(), current.getMonth(), current.getDate() + 6 - weekday);
            break;
          case 'PageUp':
            target = addMonths(current, -1);
            break;
          case 'PageDown':
            target = addMonths(current, 1);
            break;
          default:
            return;
        }

        event.preventDefault();
        if (target < this.min) target = this.min;
        if (target > this.max) target = this.max;

        if (monthIndex(target) !== monthIndex(this.month)) {
          this.month = new Date(target.getFullYear(), target.getMonth(), 1);
          this.render(target);
        }
        this.focusDay(target);
      }

      setGuests(count) {
        this.guests = Math.min(MAX_GUESTS, Math.max(1, count));
        this.guestsCount.textContent = this.guests;
        this.minus.disabled = this.guests <= 1;
        this.plus.disabled = this.guests >= MAX_GUESTS;
        if (this.minus.disabled && document.activeElement === this.minus) this.plus.focus();
        if (this.plus.disabled && document.activeElement === this.plus) this.minus.focus();
        this.updateLink();
      }

      updateLink() {
        if (!this.selected) return;
        const url = new URL(this.bathhouseUrl, window.location.origin);
        url.searchParams.set('guest', this.guests);
        url.searchParams.set('start', toIso(this.selected));
        this.continueLink.href = url.toString();
      }

      select(date) {
        this.selected = date;
        const iso = date ? toIso(date) : '';

        this.daysBody?.querySelectorAll('.sbm__day').forEach((day) => {
          day.setAttribute('aria-pressed', day.dataset.date === iso ? 'true' : 'false');
        });

        if (date) {
          this.dateLine.textContent = `${DAYS[date.getDay()].slice(0, 3)} ${date.getDate()} ${MONTHS[date.getMonth()].slice(0, 3)} ${date.getFullYear()}`;
          this.dateLine.classList.remove('sbm__date--empty');
          this.continueLink.removeAttribute('aria-disabled');
          this.updateLink();
        } else {
          this.dateLine.textContent = 'Choose a date';
          this.dateLine.classList.add('sbm__date--empty');
          this.continueLink.removeAttribute('href');
          this.continueLink.setAttribute('aria-disabled', 'true');
        }
      }
    }

    customElements.define('soma-book-menu', SomaBookMenu);
  }

  if (!customElements.get('soma-book-link')) {
    const HASHES = ['#header-book', '#header-book-bathhouse'];

    class SomaBookLink extends HTMLElement {
      constructor() {
        super();
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onHashChange = this.onHashChange.bind(this);
      }

      connectedCallback() {
        this.url = this.dataset.url || '';
        if (!this.url) return;
        document.addEventListener('click', this.onDocumentClick);
        window.addEventListener('hashchange', this.onHashChange);
        this.onHashChange();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        window.removeEventListener('hashchange', this.onHashChange);
      }

      onDocumentClick(event) {
        const link = event.target.closest?.('a[href*="#header-book"]');
        if (!link || !HASHES.includes(link.hash)) return;
        if (link.origin !== location.origin || link.pathname !== location.pathname) return;
        event.preventDefault();
        window.location.assign(this.url);
      }

      onHashChange() {
        if (HASHES.includes(location.hash)) window.location.replace(this.url);
      }
    }

    customElements.define('soma-book-link', SomaBookLink);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["soma-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('soma-carousel')) {
    class SomaCarousel extends HTMLElement {
      constructor() {
        super();
        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);
        this.onKeydown = this.onKeydown.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onSlideClick = this.onSlideClick.bind(this);
        this.update = this.update.bind(this);
        this.tween = this.tween.bind(this);
        this.init = this.init.bind(this);
      }

      connectedCallback() {
        this.viewport = this.querySelector('.sc__viewport');
        if (!this.viewport) return;

        if (window.EmblaCarousel) {
          this.init();
        } else if (window.somaLoadScript) {
          // Embla is loaded on demand (see layout/theme.liquid)
          window.somaLoadScript('embla').then(this.init);
        } else if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.init, { once: true });
        } else {
          window.addEventListener('load', this.init, { once: true });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.init);
        window.removeEventListener('load', this.init);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (!this.embla) return;

        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.viewport.removeEventListener('keydown', this.onKeydown);
        this.viewport.removeEventListener('click', this.onSlideClick, true);
        this.clearFocus();
        this.embla.destroy();
        this.embla = null;
        this.classList.remove('sc--ready');
      }

      init() {
        if (this.embla || !this.isConnected || !window.EmblaCarousel) return;

        this.slides = Array.from(this.viewport.querySelectorAll(':scope > .sc__track > .sc-slide'));
        if (this.slides.length === 0) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.loop = this.hasAttribute('data-loop');
        this.featured = this.hasAttribute('data-featured');
        this.featuredQuery = window.matchMedia('(min-width: 750px)');
        this.arrows = this.querySelector('.sc__arrows');
        this.prev = this.querySelector('.sc__arrow--prev');
        this.next = this.querySelector('.sc__arrow--next');

        this.slides.forEach((slide, index) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', `${index + 1} of ${this.slides.length}`);
          slide.querySelectorAll('img').forEach((img) => (img.draggable = false));
        });

        this.viewport.scrollLeft = 0;
        this.classList.add('sc--ready');
        this.embla = window.EmblaCarousel(this.viewport, {
          align: 'start',
          containScroll: 'trimSnaps',
          loop: this.loop,
          slidesToScroll: 1,
          duration: 25,
          breakpoints: this.featured ? { '(min-width: 750px)': { align: 'center', containScroll: false } } : {},
        });

        this.embla.on('select', this.update).on('reInit', this.update);
        if (this.featured) {
          this.embla.on('scroll', this.tween).on('select', this.tween).on('settle', this.tween).on('reInit', this.tween);
          this.viewport.addEventListener('click', this.onSlideClick, true);
        }
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
        this.viewport.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.update();
        if (this.featured) this.tween();
      }

      clearFocus() {
        this.slides.forEach((slide) => {
          slide.classList.remove('sc-slide--active');
          slide.style.removeProperty('--sc-focus');
        });
      }

      tween() {
        if (!this.embla) return;
        if (!this.featuredQuery.matches) {
          this.clearFocus();
          return;
        }

        const engine = this.embla.internalEngine();
        const progress = this.embla.scrollProgress();
        const snaps = this.embla.scrollSnapList();
        const selected = this.embla.selectedScrollSnap();

        snaps.forEach((snap, snapIndex) => {
          engine.slideRegistry[snapIndex].forEach((slideIndex) => {
            let distance = snap - progress;

            engine.slideLooper.loopPoints.forEach((point) => {
              const target = point.target();
              if (point.index !== slideIndex || target === 0) return;
              distance = target < 0 ? snap - (1 + progress) : snap + (1 - progress);
            });

            const focus = Math.min(Math.max(1 - Math.abs(distance * snaps.length), 0), 1);
            const slide = this.slides[slideIndex];
            slide.style.setProperty('--sc-focus', focus.toFixed(3));
            slide.classList.toggle('sc-slide--active', snapIndex === selected);
          });
        });
      }

      onSlideClick(event) {
        if (event.defaultPrevented || !this.featuredQuery.matches) return;

        const slide = event.target.closest('.sc-slide');
        const index = this.slides.indexOf(slide);
        if (index < 0 || slide.classList.contains('sc-slide--active')) return;

        event.preventDefault();
        event.stopPropagation();
        this.embla.scrollTo(index, this.reducedMotion.matches);
      }

      go(direction) {
        if (!this.embla) return;

        if (this.reducedMotion.matches) {
          const count = this.embla.scrollSnapList().length;
          const target = this.embla.selectedScrollSnap() + direction;
          this.embla.scrollTo(this.loop ? (target + count) % count : target, true);
        } else if (direction < 0) {
          this.embla.scrollPrev();
        } else {
          this.embla.scrollNext();
        }
      }

      update() {
        if (!this.embla || !this.arrows) return;

        this.arrows.hidden = this.embla.scrollSnapList().length <= 1;
        this.prev.disabled = !this.embla.canScrollPrev();
        this.next.disabled = !this.embla.canScrollNext();
      }

      onKeydown(event) {
        if (event.target !== this.viewport) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(1);
        }
      }

      onBlockSelect(event) {
        if (!this.embla || !this.contains(event.target)) return;

        const slide = event.target.closest('.sc-slide');
        const index = this.slides.indexOf(slide);
        if (index < 0) return;

        const lastSnap = this.embla.scrollSnapList().length - 1;
        this.embla.scrollTo(Math.min(index, lastSnap), this.reducedMotion.matches);
      }
    }

    customElements.define('soma-carousel', SomaCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
